// Mini components for reusable title and description

import { cn } from "@app/lib/utils";

type SectionTitleProps = {
  children: React.ReactNode;
  className?: string;
};

export function SectionTitle({ children, className = "" }: SectionTitleProps) {
  return (
    <h2
      className={`pb-1 text-3xl font-medium leading-tight text-white sm:text-4xl md:text-5xl lg:text-6xl xl:text-[64px] 2xl:text-7xl ${className}`}
    >
      {children}
    </h2>
  );
}

type SectionDescriptionProps = {
  children: React.ReactNode;
  className?: string;
};

export function SectionDescription({
  children,
  className = "",
}: SectionDescriptionProps) {
  return (
    <p
      className={cn(
        "my-4 text-base font-light leading-relaxed text-titanium-grey sm:text-lg sm:leading-loose md:text-xl md:leading-[35px] lg:!text-xl lg:leading-[43px]",
        className,
      )}
    >
      {children}
    </p>
  );
}

type SectionImageProps = {
  src: string;
  alt: string;
  className?: string;
};

export function SectionImage({ src, alt, className = "" }: SectionImageProps) {
  return (
    <div
      className={`relative mx-auto h-48 w-full max-w-full overflow-hidden rounded-xl sm:h-56 sm:max-w-md sm:rounded-2xl md:h-72 md:max-w-lg lg:mx-0 lg:h-80 lg:max-w-2xl xl:h-96 xl:max-w-3xl 2xl:max-h-[468px] 2xl:max-w-[809px] ${className}`}
    >
      <img src={src} alt={alt} className="h-full w-full object-cover" />
    </div>
  );
}
